import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    tasks: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_TASK_SELECT_IDS (store, ids) {
      store.tasks.selectIds = ids
    },
    REMOVE_TASK_SELECT_IDS (store, ids) {
      store.tasks.selectIds = store.tasks.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_TASK_SELECT_ID (store, id) {
      store.tasks.selectId = id
    },
    SET_TASK_FILTERS (store, filters) {
      store.tasks.filters = filters
    },
    SET_TASK_PAGINATE (store, val) {
      store.tasks.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getTasks: (store, getters) => {
      return store.tasks.selectIds.map((id) => {
        return getters['entities/tasks/find'](id)
      })
    },
    getTasksFilters: (store, getters) => {
      return store.tasks.filters
    },
    getTasksPaginate: (store, getters) => {
      return store.tasks.paginate
    },
    getTask: (store, getters) => {
      return getters['entities/tasks/find'](store.tasks.selectId) || {}
    }
  },
  actions: {
    /*
    selectTasks
    */
    selectTasks ({commit, dispatch, getters, state}, filters) {
      return dispatch('getTasks', filters)
      .then((response) => {
        commit('SET_TASK_FILTERS', filters)
        commit('SET_TASK_PAGINATE', response)
        commit('SET_TASK_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectTasks
    */
    refreshSelectTasks ({commit, dispatch, getters, state}) {
      return dispatch('selectTasks', getters.getTasksFilters)
    },
    /*
    selectTask
    */
    selectTask ({commit, dispatch, getters, state}, id) {
      return dispatch('getTaskById', id)
      .then((response) => {
        commit('SET_TASK_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getTasks
    */
    getTasks ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/tasks`, {params: filters})
      .then((response) => {
        return dispatch('entities/tasks/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.tasks || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getTaskById
    */
    getTaskById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/tasks/${id}`)
      .then((response) => {
        return dispatch('entities/tasks/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.tasks[0]
      })
    },
    /*
    createTask
    */
    createTask ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/tasks`, data)
      .then((response) => {
        return dispatch('entities/tasks/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.tasks[0]
      })
    },
    /*
    updateTask
    */
    updateTask ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/tasks/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/tasks/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.tasks[0]
      })
    },
    /*
    deleteTask
    */
    deleteTask ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/tasks/${id}`)
      .then((response) => {
        commit('REMOVE_TASK_SELECT_IDS', [id])
        dispatch('entities/tasks/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Task.js